export default __webpack_public_path__ + "static/s-615c4f493585654a68f5f4c6d1395b61.webp";